.sectionContainer {
    flex-direction: column;
    flex: 1 1 30%;
}

.effectivenessContainer {
    height: 100%;
}

.effectivenessLayout {
    margin-top: 10px;
    color: var(--hps-white);
}

.detailRow {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.detailRowMultipleColumns {
    display: flex;
    justify-content: space-between;
    width: 100%;
}
